<plyca-ui-banner-generic
  [config]="{
    classButtonClose: '',
    isButtonClose: true,
    iconCloseClass: 'fa fa-close text-white',
    background: 'bg-azul1',
    iconMain: 'mt-2 ml-1 fa fa-info fa-3x'
  }"
  (clickEvent)="onClickClose()"
>
  <h2 class="font-bold" [innerHTML]="'TEST'"></h2>
</plyca-ui-banner-generic>
<br />

<plyca-ui-banner-generic
  [config]="{
    classButtonClose: '',
    isButtonClose: false,
    iconCloseClass: '',
    background: 'bg-warning',
    iconMain: 'mt-2 ml-1 fa fa-info fa-3x'
  }"
  (clickEvent)="onClickClose()"
>
  <h2 class="font-bold" [innerHTML]="'TEST'"></h2>
</plyca-ui-banner-generic>
<br />
